import { Pipe, PipeTransform } from '@angular/core'
import { orderBy } from 'lodash'

@Pipe({
  name: 'gbOrderBy',
})
export class GbOrderByPipe implements PipeTransform {
  transform(arr: any[] | null, keys: string): any[] {
    const ordering = keys.split(',')
    return orderBy(arr, ordering)
  }
}
